// Port of api/fuel/app/classes/filter/search/games/filters/query/play/outcome.php
export default {
	name: 'play.outcome',
	priority: 60,
	require: function(config, filter) { return filter.play && filter.play.outcome },
	run: function(config, filter, data, query) {
		if (filter.play.outcome === 1) {
			query.where('p.play_result', '=', 1)
			query.where('p.play_won', '=', 1)
		} else if (filter.play.outcome === 2) {
			query.where('p.play_result', '=', 1)
			query.where('p.play_won', '=', 0)
		} else if (filter.play.outcome === 3) {
			query.where('p.play_result', '=', 0)
		}
	}
}
